import $ from 'jquery';
import 'slick-carousel';
import { throttle } from 'underscore';

$(() => {
    const headerHeight = 80;
    const $loginMask = $('.login-mask');
    const $menu = $('.menu');
    const $menuToggle = $('.menu-toggle');

    /**
     * Show the navigation
     */
    function showMenu() {
        $menu.addClass('menu-visible');
        $menuToggle.addClass('open-menu');
    }

    /**
     * Hide the navigation
     */
    function hideMenu() {
        $menu.removeClass('menu-visible');
        $menuToggle.removeClass('open-menu');
    }

    /**
     * Toggle the navigation
     */
    function toggleMenu() {
        const menuIsVisible = $menu.hasClass('menu-visible');

        if (menuIsVisible) {
            hideMenu();
        } else {
            showMenu();
        }
    }

    /**
     * Scroll the body to the given position with animation
     *
     * @param {number} offset
     */
    function scrollTo(offset) {
        $('html, body').stop(true).animate({
            scrollTop: offset - headerHeight,
        }, 1000);
    }

    /**
     * Get the positions of the navigaton headers
     *
     * @return {Object[]}
     */
    function getOffsets() {
        const offsets = [];

        $('.header .menu a').each((index, item) => {
            const idSelector = $(item).attr('href');
            const elmOffset = $(idSelector).offset();
            const offsetTop = Math.floor(elmOffset.top);

            offsets.push({
                offset: offsetTop,
                selector: idSelector,
            });
        });

        return offsets;
    }

    /**
     * @param {*} offset
     * @return {*}
     */
    function getOffsetRange(offset) {
        const offsets = getOffsets();
        let selector;

        $(offsets).each((index, pos) => {
            if ((offset + headerHeight) >= pos.offset) {
                selector = pos.selector;
            }
        });

        return selector;
    }

    $('#toggle-btn').on('click', function onToggleClick(event) {
        event.preventDefault();

        $loginMask
            .toggleClass('open')
            .stop(true)
            .slideToggle(500);

        const $this = $(this);
        const openText = $this.data('open-text');
        const closeText = $this.data('close-text');
        const maskIsOpen = !!$loginMask.hasClass('open');

        $this.text((maskIsOpen) ? closeText : openText);

        scrollTo(0);
    });

    $('.menu a, a[href="#contact"]').on('click', function onNavigationClick() {
        if (
            window.location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
            && window.location.hostname === this.hostname
        ) {
            let target = $(this.hash);
            target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
            if (target.length) {
                scrollTo(target.offset().top);
                return false;
            }
        }

        return true;
    });

    $menuToggle.on('click', toggleMenu);

    $('.menu a').on('click', hideMenu);

    $(window).on('scroll', throttle((event) => {
        const offset = event.currentTarget.pageYOffset;
        const selector = getOffsetRange(offset);

        $('.menu a').removeClass('active');
        $(`.menu a[href="${selector}"]`).addClass('active');
    }, 250));
});

$(document).ready(() => {
    $('.production-slide').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        variableWidth: true,
        centerMode: true,
        arrows: true,
    });
});
